import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62f4c554&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=62f4c554&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f4c554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f4c554')) {
      api.createRecord('62f4c554', component.options)
    } else {
      api.reload('62f4c554', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62f4c554&scoped=true", function () {
      api.rerender('62f4c554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/index.vue"
export default component.exports